import React, { Fragment, lazy, Suspense } from "react";
import { useTranslate } from "@customHooks/useTranslate.js";
import Loading from "@genericComponents/Loading.js";
const RenderHTML = lazy(() => import("@controls/RenderHTML.js"));
const Label = ({ tranVal, isPlain = false, className, category = null }) => {
  const transResult = useTranslate(tranVal, category);
  if (!tranVal) {
    return <Fragment />;
  }
  const RenderFragmentStyle = ({ children }) => {
    if (className) {
      return (
        <span className={className}>
          <Suspense fallback={<Loading />}>
            <RenderHTML paramHTML={children} />
          </Suspense>
        </span>
      );
    } else {
      return (
        <Suspense fallback={<Loading />}>
          <RenderHTML paramHTML={children} />
        </Suspense>
      );
    }
  };
  if (isNaN(tranVal)) {
    return <RenderFragmentStyle>{tranVal.toString()}</RenderFragmentStyle>;
  }
  if (!transResult?.length) {
    return <Fragment />;
  } else if (!isPlain) {
    return (
      <label translated={tranVal}>
        <RenderFragmentStyle>{transResult.trim()}</RenderFragmentStyle>
      </label>
    );
  } else {
    return <RenderFragmentStyle>{transResult.trim()}</RenderFragmentStyle>;
  }
};
export default Label;
